import { render, staticRenderFns } from "./InformedDeliverySignup.vue?vue&type=template&id=76f330a8"
import script from "./InformedDeliverySignup.vue?vue&type=script&lang=js"
export * from "./InformedDeliverySignup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports